import React from "react";
import styled from "styled-components";
import { Box, Card, Icon, Typography } from "@bca/ui-library";

import { formatMoney } from "./formatMoney";

const ReserveMet = styled(Box)`
  border-radius: 4px;
`;

const ReserveNotMet = styled(Box)`
  border: 1px solid #64798c;
  border-radius: 4px;
`;

const HighestBidder: React.FunctionComponent<{
  bidAmount: number;
  reserveMet: boolean;
}> = ({ bidAmount, reserveMet }) => {
  return (
    <Card
      width={["100%", "100%", 620]}
      height="auto"
      marginX={0}
      marginY={0}
      paddingX={28}
      paddingY={28}
    >
      <Box
        display="flex"
        justifyContent="flex-start"
        alignItems="center"
        mb={2}
      >
        {reserveMet && (
          <Icon
            name="check-circle"
            data-testid="icon-container-check-circle"
            weight="solid"
            color="secondary-green"
            height={24}
            width={24}
            mr={3}
          />
        )}
        <Typography
          variant="h6"
          color={reserveMet ? "secondary-green" : "primary-black"}
          m={0}
        >
          {reserveMet
            ? "Congratulations, you were the highest bidder"
            : "You were the highest bidder but the reserve was not met"}
        </Typography>
      </Box>
      <Box
        display="flex"
        justifyContent="flex-start"
        alignItems="center"
        mb={2}
      >
        <Typography
          css={`
            font-size: 30px;
            font-weight: 500;
          `}
          m={0}
          mr={3}
        >
          {formatMoney(bidAmount)}
        </Typography>
        {reserveMet && (
          <ReserveMet backgroundColor="grey-blue" height={26} py={0} px="10px">
            <Typography
              variant="caption"
              color="primary-white"
              m={0}
              css={`
                font-size: 13px;
                line-height: 24px;
              `}
            >
              Reserve met
            </Typography>
          </ReserveMet>
        )}
        {!reserveMet && (
          <ReserveNotMet backgroundColor="white" height={26} py={0} px={"10px"}>
            <Typography
              variant="caption"
              color="grey-blue"
              m={0}
              css={`
                font-size: 13px;
                line-height: 24px;
              `}
            >
              Provisional
            </Typography>
          </ReserveNotMet>
        )}
      </Box>
      <Typography variant="body" color="grey-blue" m={0}>
        {reserveMet
          ? "Your purchase will show in MyBCA shortly, where you will be able to make a payment, book a delivery or arrange a collection."
          : "We’ll be in touch shortly to let you know the outcome. Check your email and MyBCA soon."}
      </Typography>
    </Card>
  );
};

export default HighestBidder;
